var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKitMediaWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194.728,
    height: 217.823,
    viewBox: "0 0 194.728 217.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10984",
    "data-name": "Group 10984",
    transform: "translate(514 19792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28411",
    "data-name": "Path 28411",
    d: "M94.938,106.011a4.57,4.57,0,0,0,2.46-5.976,4.627,4.627,0,0,0-.375-.714l10.024-12.777-8.411-.693L90.407,98.09a4.595,4.595,0,0,0,4.531,7.921",
    transform: "translate(-514 -19792)",
    fill: "#f8c3a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28412",
    "data-name": "Path 28412",
    d: "M42.766,102.779c.1-2.5.257-4.1.436-4.1h65.614c.179,0,.334,1.609.436,4.1.068,1.74.111,3.911.111,6.261v45.717l-.266.034L98.31,156.2l-11.243,1.473-5.137.669-10.983,1.434-9.125,1.192a.475.475,0,0,0-.121.01c-.058-.01-.116-.019-.17-.034l-3.591-1.168L53.8,158.425l-10.874-3.538-.266-.087V109.04c0-2.351.041-4.522.109-6.261",
    transform: "translate(-514 -19792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28413",
    "data-name": "Path 28413",
    d: "M42.548,101.7c.034-.649.068-1.173.107-1.59a8.3,8.3,0,0,1,.184-1.294c.107-.407.228-.407.364-.407h65.615c.136,0,.257,0,.363.407a9.538,9.538,0,0,1,.184,1.357c.034.407.068.911.1,1.526.107,1.963.165,4.57.165,7.342v45.678l-.266.039-.266.034V109.04c0-2.413-.044-4.458-.107-6.072a28.357,28.357,0,0,0-.325-4.032H43.348a28.143,28.143,0,0,0-.325,4.027c-.058,1.614-.1,3.659-.1,6.077v45.848l-.533-.174V109.04c0-2.772.056-5.379.158-7.341",
    transform: "translate(-514 -19792)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28414",
    "data-name": "Path 28414",
    d: "M88.652,112.611h8.369a1.581,1.581,0,0,1,1.585,1.577v7.253a1.582,1.582,0,0,1-1.579,1.585H88.652a1.585,1.585,0,0,1-1.585-1.585v-7.25a1.583,1.583,0,0,1,1.585-1.58",
    transform: "translate(-514 -19792)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28415",
    "data-name": "Path 28415",
    d: "M54.13,115.417H83.305a.717.717,0,0,1,0,1.434H54.13a.717.717,0,0,1,0-1.434",
    transform: "translate(-514 -19792)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28416",
    "data-name": "Path 28416",
    d: "M72.225,118.785H83.3a.717.717,0,0,1,0,1.434H72.225a.717.717,0,1,1,0-1.434Z",
    transform: "translate(-514 -19792)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28417",
    "data-name": "Path 28417",
    d: "M88.653,134.069h8.369a1.585,1.585,0,0,1,1.585,1.585v7.25a1.585,1.585,0,0,1-1.585,1.585H88.653a1.588,1.588,0,0,1-1.585-1.585v-7.253a1.588,1.588,0,0,1,1.585-1.585Z",
    transform: "translate(-514 -19792)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28418",
    "data-name": "Path 28418",
    d: "M54.13,136.875H83.3a.72.72,0,0,1,.054,1.439.483.483,0,0,1-.054,0H54.13a.72.72,0,0,1,0-1.439",
    transform: "translate(-514 -19792)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28419",
    "data-name": "Path 28419",
    d: "M72.225,140.243H83.3a.72.72,0,0,1,.054,1.439H72.225a.72.72,0,0,1,0-1.439",
    transform: "translate(-514 -19792)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28420",
    "data-name": "Path 28420",
    d: "M87.3,156.3a1.574,1.574,0,0,1,1.357-.771h8.369a1.575,1.575,0,0,1,1.289.664l-11.243,1.473v-.557a1.548,1.548,0,0,1,.228-.809",
    transform: "translate(-514 -19792)",
    fill: "#685ef7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28421",
    "data-name": "Path 28421",
    d: "M54.13,158.34h27.8l-10.986,1.434H57.938l-4.143-1.347a.647.647,0,0,1,.335-.087",
    transform: "translate(-514 -19792)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28422",
    "data-name": "Path 28422",
    d: "M157.285,11.86c-1.576-5.023-5.16-9.63-10.117-11.328s-12.216.889-15.943,4.6c-6.817,6.794-8.481,30.133-3.8,37.509.932-.049,4.146-.086,5.089-.121l1.334-4.445v4.4c7.359-.227,15.021-.085,22.687.062.689-5.219,2.328-25.654.75-30.677",
    transform: "translate(-514 -19792)",
    fill: "#1b1b22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28423",
    "data-name": "Path 28423",
    d: "M131.557,43.316l-2.34-3.928s-3.257-.173-7.371,4.9-26.782,46.6-26.782,46.6l9.741-1.2L128,61.5Z",
    transform: "translate(-514 -19792)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28434",
    "data-name": "Path 28434",
    d: "M144.066,205.816l-5.925-1.236,1.945-23.442,8.745,1.824Z",
    transform: "translate(-514 -19792)",
    fill: "#f8c3a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28435",
    "data-name": "Path 28435",
    d: "M146.689,203.31,144.918,217.7v.029l-.138-.029-4.067-.849.076-4.125-2.748,3.571-2.631-.547-5.313-1.108-.43-.088-1.64-.342-1.137-.237a2.563,2.563,0,0,1-1.494-4.085,2.624,2.624,0,0,1,.743-.645c.036-.018.073-.04.109-.058.055-.029.109-.055.168-.08l.1-.044,1.738-.733h.007l4.588-1.931,3.754-1.582.835-4.013,1,.273,6.268,1.7Z",
    transform: "translate(-514 -19792)",
    fill: "#1b1b22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28436",
    "data-name": "Path 28436",
    d: "M184.788,186.677l-4.6,3.932L162.83,174.732l6.791-5.8Z",
    transform: "translate(-514 -19792)",
    fill: "#f8c3a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28437",
    "data-name": "Path 28437",
    d: "M191.466,196.09l-3.218-2.585,1.141,4.357-8.659,7.4a2.513,2.513,0,0,1-.864.486,2.57,2.57,0,0,1-3.362-2.372,2.557,2.557,0,0,1,.085-.718l2.835-10.686-2.665-3.115.829-.625,5.179-3.92,1.638-1.239L194.728,193.3Z",
    transform: "translate(-514 -19792)",
    fill: "#1b1b22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28438",
    "data-name": "Path 28438",
    d: "M161.512,93.072l-28.526-1.1-1.073-28.943,24.1.774Z",
    transform: "translate(-514 -19792)",
    fill: "#f8c3a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28439",
    "data-name": "Path 28439",
    d: "M140.183,6.781A10.863,10.863,0,1,1,129.32,17.644,10.864,10.864,0,0,1,140.183,6.781",
    transform: "translate(-514 -19792)",
    fill: "#f8c3a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28440",
    "data-name": "Path 28440",
    d: "M149.558,8.1,137.05,1.84a15.722,15.722,0,0,0-9.208,13.026L127.53,18.6l5.238-1.333.574-4.775.889,4.4,2.417-.615-.023-7.414,2.419,7.408,8.633-1.983Z",
    transform: "translate(-514 -19792)",
    fill: "#1b1b22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28441",
    "data-name": "Path 28441",
    d: "M132.437,85.387s-9.5,16.519-.328,41.582l12.973,33.091,22.545,22.815,12.116-7.162-22.527-19.1,10.046-34.055a59.187,59.187,0,0,0,2.1-23.83c-.724-5.989-6.128-10.662-9.825-16.314-12.348,7.964-26.567,6.683-27.1,2.973",
    transform: "translate(-514 -19792)",
    fill: "#1b1b22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28442",
    "data-name": "Path 28442",
    d: "M145.069,151.694l-8.459,39.294,12.237,2.307,6.968-33.033Z",
    transform: "translate(-514 -19792)",
    fill: "#1b1b22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28443",
    "data-name": "Path 28443",
    d: "M148.144,32.14l-14.045.187-4.571,5.8a11.443,11.443,0,0,0-8.648,9.186l-.431,2.492a22.323,22.323,0,0,0,2.676,14.989l8.575,8.094-.372.676a1.547,1.547,0,0,0,.466,2.012,3.162,3.162,0,0,0-.087,2.081l.181.6s-4.807,1.278,24.852-3.124a2.924,2.924,0,0,0,2.468-2.512,2.185,2.185,0,0,0,.4-2.516l-.06-.121.3-.359a2.349,2.349,0,0,0,.119-2.887l.078-17a10.862,10.862,0,0,0-7.528-11.875Z",
    transform: "translate(-514 -19792)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28444",
    "data-name": "Path 28444",
    d: "M108.192,104.8a4.568,4.568,0,0,1,5.42-4.441L121.7,86.276l3.8,7.536-8.26,12.217a4.594,4.594,0,0,1-9.041-1.23Z",
    transform: "translate(-514 -19792)",
    fill: "#f8c3a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28445",
    "data-name": "Path 28445",
    d: "M152.587,47.35l4.516.7s1.381,2.953-1.78,8.67-33.156,42.3-33.156,42.3l-2.535-9.48,17.434-32.072Z",
    transform: "translate(-514 -19792)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28446",
    "data-name": "Path 28446",
    d: "M123.04,156.7v53.45a7.675,7.675,0,0,1-7.675,7.675H7.675A7.675,7.675,0,0,1,0,210.148V144.253a7.675,7.675,0,0,1,7.675-7.675h9.157a7.671,7.671,0,0,1,4.4,1.39l13.787,9.664a7.672,7.672,0,0,0,4.405,1.391h75.936a7.675,7.675,0,0,1,7.675,7.675",
    transform: "translate(-514 -19792)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5355",
    "data-name": "Rectangle 5355",
    width: 50.248,
    height: 3.992,
    rx: 1.996,
    transform: "translate(-506.484 -19587.096)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5356",
    "data-name": "Rectangle 5356",
    width: 25.124,
    height: 3.992,
    rx: 1.996,
    transform: "translate(-506.487 -19594.844)",
    fill: "#e6e7eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitMediaWeb);
export default __webpack_public_path__ + "static/media/KitMediaWeb.d041d8da39718972371b13f354297c22.svg";
export { ForwardRef as ReactComponent };